import React, {useEffect, useState} from "react";
import {Box, Button, Chip, Menu, OutlinedInput, Typography,} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {ArrowDropDown} from "@mui/icons-material";
import CustomCheckbox from "../../../../../../components/Checkbox";
import TextInput from "../../../../../../components/TextInput";

const HotelGroupDropdown = ({
    data,
    selectedItem,
    setSelectedItem,
    selectedType,
    setSelectedType,
    setSelectedCategory,
    setPage
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [localList, setLocalList] = useState([]);

    const open = Boolean(anchorEl);

    useEffect(() => {
        if (data) {
            const sourceList =
                selectedType === "hotels" ? data.hotels_list : data.groups_list;
            const initializedList = sourceList.map((item) => ({
                ...item,
                isSelected: item.isSelected ?? false,
            }));
            setLocalList(initializedList);
        }
    }, [data, selectedType]);

    useEffect(() => {
        if (selectedItem.length > 0) {
            setLocalList((prevList) =>
                prevList.map((item) => ({
                    ...item,
                    isSelected: selectedItem.some((selected) => selected.id === item.id),
                }))
            );
        }
    }, [selectedItem]);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <div className="form-grid-item bidding_multiplier_height">
                <Box
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        fontSize: "10px",
                        lineHeight: "100%",
                        color: "#373F41",
                    }}
                    pb={1}
                >
                    SELECT HOTEL OR GROUP
                </Box>
                <TextInput
                    placeholder={" Select a value "}
                    type="text"
                    readOnly
                    value={
                        selectedItem.length > 0
                            ? selectedItem.length === 1
                                ? selectedItem[0].name
                                : `${selectedItem.length} selected`
                            : ""
                    }
                    sx={{
                        backgroundColor: "white",
                        fontSize: "12px",
                        fontWeight: "400",
                        paddingLeft: "4px",
                        maxWidth: "300px",
                        minWidth: "300px",
                        minHeight: "28px",
                        maxHeight: "28px",
                    }}
                    endAdornment={<ArrowDropDown />}
                    onClick={handleClick}
                />
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    sx={{ padding: 0 }}
                    PaperProps={{
                        sx: {
                            borderRadius: "10px",
                            maxWidth: "300px",
                            minWidth: "140px",
                        },
                    }}
                >
                    <Box sx={{ padding: "17px" }}>
                        <Typography
                            sx={{ fontSize: "10px", color: "#C4C4C4", marginBottom: "10px" }}
                        >
                            Select
                        </Typography>
                        <Box className="flex" sx={{ marginBottom: "10px" }}>
                            <Chip
                                label="Hotels"
                                onClick={() => setSelectedType("hotels")}
                                sx={{
                                    backgroundColor:
                                        selectedType === "hotels" ? "#61D5A9" : "none",
                                    marginRight: "10px",
                                    height: "20px",
                                    width: "92px",
                                }}
                            />
                            {data.can_use_group && (
                                <Chip
                                    label="Groups"
                                    onClick={() => setSelectedType("groups")}
                                    sx={{
                                        backgroundColor: selectedType === "groups" ? "#61D5A9" : "none",
                                        marginRight: "4px",
                                        height: "20px",
                                        width: "92px",
                                    }}
                                />
                            )}
                        </Box>
                        <OutlinedInput
                            sx={{
                                borderRadius: "10px",
                                borderColor: "#CADEDD",
                                width: "195px",
                                height: "28px",
                                fontSize: "12px",
                                marginBottom: '5px'
                            }}
                            size="small"
                            placeholder="Search"
                            value={searchTerm}
                            startAdornment={
                                <SearchIcon sx={{ color: "#CADEDD", fontSize: "18px" }} />
                            }
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <Box sx={{ marginTop: "5px" }}>
                            <CustomCheckbox
                                title={selectedType === "hotels" ? "All hotels" : "All groups"}
                                labelStyles={{ color: "#C4C4C4" }}
                                fontSize="10px"
                                size={"small"}
                                checked={localList.length > 0 && localList.every((item) => item.isSelected)}
                                onChange={() => {
                                    const allSelected = localList.every((item) => item.isSelected);
                                    setLocalList((prev) =>
                                        prev.map((item) => ({
                                            ...item,
                                            isSelected: !allSelected,
                                        }))
                                    );
                                }}
                            />
                            <ul
                                style={{
                                    listStyleType: "none",
                                    margin: 0,
                                    padding: 0,
                                    maxHeight: "250px",
                                    overflow: "auto",
                                }}
                            >
                                {localList
                                    .filter((item) => {
                                        const term = searchTerm.toLowerCase();
                                        return (
                                            item.name.toLowerCase().includes(term) ||
                                            item.id.toString().includes(term)
                                        );
                                    })
                                    .map((item) => (
                                        <li
                                            key={item.id}
                                            style={{
                                                padding: "7px",
                                                borderLeft: "1px solid #CADEDD",
                                            }}
                                        >
                                            <CustomCheckbox
                                                fontSize="12px"
                                                size={"small"}
                                                checked={item.isSelected}
                                                title={item.name}
                                                onChange={() => {
                                                    setLocalList((prev) =>
                                                        prev.map((i) =>
                                                            i.id === item.id
                                                                ? { ...i, isSelected: !i.isSelected }
                                                                : i
                                                        )
                                                    );
                                                }}
                                            />
                                        </li>
                                    ))}
                            </ul>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: "15px",
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{ color: "#C4C4C4", cursor: "pointer" }}
                                onClick={() => {
                                    setSelectedItem([]);
                                    setLocalList((prev) =>
                                        prev.map((item) => ({ ...item, isSelected: false }))
                                    );
                                    setSearchTerm("");
                                }}
                            >
                                Clear Filters
                            </Typography>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: "black",
                                    backgroundColor: "#61D5A9",
                                    borderRadius: "20px",
                                    fontSize: "10px",
                                    width: "100px",
                                    height: "22px",
                                    paddingInline: "8px",
                                }}
                                onClick={() => {
                                    setSelectedItem(localList.filter((item) => item.isSelected));
                                    setSelectedCategory(selectedType);
                                    setPage(0);
                                    handleClose();
                                }}
                            >
                                Apply
                            </Button>
                        </Box>
                    </Box>
                </Menu>
            </div>
        </Box>
    );
};

export default HotelGroupDropdown;
